// extracted by mini-css-extract-plugin
export default {"main":"xbxHC","text":"Jvj1K"};